import React from 'react';

import HowKabbageWorks from './HowKabbageWorks';
import KabbageFeatures from './KabbageFeatures';
import OptimizeTest from './OptimizeTest';
import ThreeStep from './ThreeStep';
import GetStartedToday from './GetStartedToday';

const MainContent = () => {
  return (
    <>
      <ThreeStep />
      <OptimizeTest />
      <HowKabbageWorks />
      <KabbageFeatures />
      <GetStartedToday />
    </>
  );
};

export default MainContent;
